import React, { useState, useEffect } from "react";
import axios from "axios";
import { apiBaseUrl } from '../../../../../../../services/config';
import { useTheme } from "context/ThemeContext";
const API = apiBaseUrl;
const auth = () => ({ headers: { Authorization: `Bearer ${sessionStorage.getItem("platform_token")||localStorage.getItem("platform_token")||""}` }});

const Badge = ({status}) => {
  const { T } = useTheme();
  const STATUS_CFG = {
    Pending:  { color:T.amber,  bg:`${T.amber}1A`,  label:"Pending"  },
    Approved: { color:T.green,  bg:`${T.green}1A`,  label:"Approved" },
    Rejected: { color:T.red,    bg:`${T.red}1A`,    label:"Rejected" },
  };
  const c = STATUS_CFG[status] || STATUS_CFG.Pending;
  return <span style={{padding:"3px 10px",borderRadius:100,fontSize:11,fontWeight:700,background:c.bg,color:c.color}}>{c.label}</span>;
};

const Btn = ({onClick,disabled,color="cyan",children,style={}}) => {
  const { T } = useTheme();
  return (
    <button onClick={onClick} disabled={disabled} style={{
      padding:"7px 16px",borderRadius:7,cursor:disabled?"not-allowed":"pointer",
      fontFamily:"Outfit,sans-serif",fontSize:12,fontWeight:700,
      background:color==="cyan"?`linear-gradient(135deg,${T.cyan},${T.purple})`:`${T[color]}18`,
      border:color==="cyan"?"none":`1px solid ${T[color]}35`,
      color:color==="cyan"?"#fff":T[color],opacity:disabled?0.5:1,...style
    }}>{children}</button>
  );
};

export default function CompOffAdmin() {
  const { T } = useTheme();
  const inp = (x={}) => ({
    width:"100%",padding:"9px 12px",border:`1px solid ${T.border}`,borderRadius:8,
    background:T.inp_bg,color:T.text,
    fontFamily:"Outfit,sans-serif",fontSize:13,outline:"none",boxSizing:"border-box",...x
  });

  const [requests, setRequests] = useState([]);
  const [loading,  setLoading]  = useState(false);
  const [filter,   setFilter]   = useState("Pending");
  const [modal,    setModal]    = useState(null); // {type:"approve"|"reject", req}
  const [remarks,  setRemarks]  = useState("");
  const [toast,    setToast]    = useState("");

  const flash = (msg,ok=true) => { setToast({msg,ok}); setTimeout(()=>setToast(""),3500); };

  const load = async () => {
    setLoading(true);
    try {
      const r = await axios.get(`${API}/comp-off/`, { params:{ status: filter||undefined }, ...auth() });
      setRequests(r.data);
    } catch(e) { flash(e.response?.data?.detail||"Failed to load", false); }
    finally { setLoading(false); }
  };

  useEffect(()=>{ load(); }, [filter]);

  const decide = async () => {
    const { type, req } = modal;
    const hrId = JSON.parse(sessionStorage.getItem("platform_user")||"{}").employee_id || 1;
    try {
      if (type === "approve") {
        await axios.put(`${API}/comp-off/${req.id}/approve?approved_by=${hrId}`,
          { remarks }, auth());
        flash(`✅ Approved — ${req.is_half_day?"0.5":"1"} day credited to ${req.first_name}'s leave balance`);
      } else {
        await axios.put(`${API}/comp-off/${req.id}/reject`, { remarks }, auth());
        flash(`Rejected comp-off for ${req.first_name}`);
      }
      setModal(null); setRemarks(""); load();
    } catch(e) { flash(e.response?.data?.detail||"Failed", false); }
  };

  // Summary counts
  const counts = requests.reduce((acc,r)=>{ acc[r.status]=(acc[r.status]||0)+1; return acc; }, {});

  return (
    <div style={{fontFamily:"Outfit,sans-serif",color:T.text}}>
      {/* Header */}
      <div style={{marginBottom:20}}>
        <div style={{fontSize:11,color:T.cyan,fontWeight:700,letterSpacing:"0.1em",textTransform:"uppercase",marginBottom:4}}>ATTENDANCE &amp; LEAVE</div>
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",flexWrap:"wrap",gap:12}}>
          <div>
            <h2 style={{fontSize:22,fontWeight:800,margin:"0 0 4px"}}>Comp-Off Requests</h2>
            <p style={{fontSize:13,color:T.muted,margin:0}}>Review employee requests for working on holidays or weekends</p>
          </div>
          <div style={{display:"flex",gap:8}}>
            {["All","Pending","Approved","Rejected"].map(s=>(
              <button key={s} onClick={()=>setFilter(s==="All"?"":s)}
                style={{padding:"7px 16px",borderRadius:8,border:"none",cursor:"pointer",
                  fontFamily:"Outfit,sans-serif",fontSize:12,fontWeight:700,
                  background:(filter||"All")===s?`linear-gradient(135deg,${T.cyan},${T.purple})`:T.toggle_bg,
                  color:(filter||"All")===s?"#fff":T.muted}}>
                {s} {counts[s]>0&&s!=="All"?`(${counts[s]})`:s==="All"?`(${requests.length})`:""}
              </button>
            ))}
          </div>
        </div>
      </div>

      {/* Summary cards */}
      <div style={{display:"flex",gap:10,marginBottom:20,flexWrap:"wrap"}}>
        {[
          {label:"Pending Review",count:counts.Pending||0,color:T.amber},
          {label:"Approved",      count:counts.Approved||0,color:T.green},
          {label:"Rejected",      count:counts.Rejected||0,color:T.red},
          {label:"Total",         count:requests.length,   color:T.cyan},
        ].map(c=>(
          <div key={c.label} style={{padding:"14px 20px",background:T.card,border:`1px solid ${T.border}`,borderRadius:10,flex:1,minWidth:120}}>
            <div style={{fontSize:10,color:T.muted,fontWeight:700,textTransform:"uppercase",letterSpacing:"0.08em",marginBottom:5}}>{c.label}</div>
            <div style={{fontSize:24,fontWeight:900,color:c.color}}>{c.count}</div>
          </div>
        ))}
      </div>

      {/* Table */}
      <div style={{background:T.card,border:`1px solid ${T.border}`,borderRadius:12,overflow:"hidden"}}>
        <div style={{overflowX:"auto"}}>
          <table style={{width:"100%",borderCollapse:"collapse"}}>
            <thead>
              <tr style={{background:T.card2}}>
                {["Employee","Dept","Worked Date","Type","Reason","Status","Submitted","Remarks","Action"].map(h=>(
                  <th key={h} style={{padding:"11px 14px",textAlign:"left",fontSize:10,color:T.dim,fontWeight:700,textTransform:"uppercase",letterSpacing:"0.06em",borderBottom:`1px solid ${T.border}`,whiteSpace:"nowrap"}}>{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {loading && (
                <tr><td colSpan={9} style={{padding:32,textAlign:"center",color:T.muted}}>Loading…</td></tr>
              )}
              {!loading && requests.length===0 && (
                <tr><td colSpan={9} style={{padding:40,textAlign:"center",color:T.dim,fontSize:13}}>No requests found</td></tr>
              )}
              {requests.map(r=>(
                <tr key={r.id} style={{borderBottom:`1px solid ${T.border}`}}
                  onMouseEnter={e=>e.currentTarget.style.background=T.sidebar_hover}
                  onMouseLeave={e=>e.currentTarget.style.background="transparent"}>
                  <td style={{padding:"11px 14px"}}>
                    <div style={{fontSize:13,fontWeight:700,color:T.text}}>{r.first_name} {r.last_name}</div>
                    <div style={{fontSize:11,color:T.muted}}>{r.employee_code}</div>
                  </td>
                  <td style={{padding:"11px 14px",fontSize:12,color:T.muted}}>{r.department_name||"—"}</td>
                  <td style={{padding:"11px 14px"}}>
                    <div style={{fontSize:13,fontWeight:700,color:T.text}}>{r.worked_date}</div>
                    <div style={{fontSize:10,color:T.dim}}>{new Date(r.worked_date+"T00:00:00").toLocaleDateString("en-IN",{weekday:"short"})}</div>
                  </td>
                  <td style={{padding:"11px 14px"}}>
                    <span style={{padding:"3px 9px",borderRadius:100,fontSize:11,fontWeight:700,background:r.is_half_day?`${T.purple}26`:`${T.cyan}1A`,color:r.is_half_day?T.purple:T.cyan}}>
                      {r.is_half_day?"Half Day":"Full Day"}
                    </span>
                  </td>
                  <td style={{padding:"11px 14px",fontSize:12,color:T.muted,maxWidth:200}}>
                    <div style={{whiteSpace:"nowrap",overflow:"hidden",textOverflow:"ellipsis",maxWidth:180}} title={r.reason}>{r.reason}</div>
                  </td>
                  <td style={{padding:"11px 14px"}}><Badge status={r.status}/></td>
                  <td style={{padding:"11px 14px",fontSize:11,color:T.dim,whiteSpace:"nowrap"}}>
                    {r.created_at ? new Date(r.created_at).toLocaleDateString("en-IN") : "—"}
                  </td>
                  <td style={{padding:"11px 14px",fontSize:12,color:T.muted,maxWidth:150}}>
                    <div style={{whiteSpace:"nowrap",overflow:"hidden",textOverflow:"ellipsis",maxWidth:140}} title={r.remarks}>{r.remarks||"—"}</div>
                  </td>
                  <td style={{padding:"11px 14px"}}>
                    {r.status==="Pending" ? (
                      <div style={{display:"flex",gap:6}}>
                        <Btn color="green" onClick={()=>{setModal({type:"approve",req:r});setRemarks("");}}>✓ Approve</Btn>
                        <Btn color="red"   onClick={()=>{setModal({type:"reject", req:r});setRemarks("");}}>✕ Reject</Btn>
                      </div>
                    ) : (
                      <span style={{fontSize:11,color:T.dim}}>
                        {r.approved_at ? new Date(r.approved_at).toLocaleDateString("en-IN") : "—"}
                      </span>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      {/* Approve / Reject modal */}
      {modal && (
        <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.6)",zIndex:500,display:"flex",alignItems:"center",justifyContent:"center",backdropFilter:"blur(4px)"}}>
          <div style={{background:T.card,border:`1px solid ${T.border}`,borderRadius:16,padding:28,width:420,fontFamily:"Outfit,sans-serif"}}>
            <h3 style={{margin:"0 0 6px",fontSize:17,fontWeight:800,color:modal.type==="approve"?T.green:T.red}}>
              {modal.type==="approve"?"✓ Approve Comp-Off":"✕ Reject Comp-Off"}
            </h3>
            <p style={{fontSize:13,color:T.muted,marginBottom:20}}>
              <strong style={{color:T.text}}>{modal.req.first_name} {modal.req.last_name}</strong> worked on{" "}
              <strong style={{color:T.cyan}}>{modal.req.worked_date}</strong>{" "}
              ({modal.req.is_half_day?"Half Day":"Full Day"})
            </p>

            {modal.type==="approve" && (
              <div style={{padding:"12px 16px",background:`${T.green}0F`,border:`1px solid ${T.green}26`,borderRadius:9,marginBottom:16,fontSize:12.5,color:T.green}}>
                ✓ <strong>{modal.req.is_half_day?"0.5":"1"} day</strong> will be credited to{" "}
                <strong>{modal.req.first_name}</strong>'s Comp-Off leave balance immediately on approval.
              </div>
            )}

            <div style={{marginBottom:20}}>
              <label style={{fontSize:11,fontWeight:700,color:T.muted,display:"block",marginBottom:5,textTransform:"uppercase",letterSpacing:"0.07em"}}>
                Remarks {modal.type==="reject"?"*":"(optional)"}
              </label>
              <textarea value={remarks} onChange={e=>setRemarks(e.target.value)}
                placeholder={modal.type==="approve"?"e.g. Approved for working on release day":"e.g. Please provide supporting evidence"}
                rows={3} style={{...inp(),resize:"vertical"}}/>
            </div>

            <div style={{display:"flex",gap:10,justifyContent:"flex-end"}}>
              <Btn color="muted" onClick={()=>setModal(null)} style={{background:T.toggle_bg,color:T.muted,border:`1px solid ${T.border}`}}>Cancel</Btn>
              <Btn color={modal.type==="approve"?"green":"red"} onClick={decide}
                disabled={modal.type==="reject"&&!remarks.trim()}>
                {modal.type==="approve"?"Approve & Credit Leave":"Reject Request"}
              </Btn>
            </div>
          </div>
        </div>
      )}

      {toast && (
        <div style={{position:"fixed",bottom:24,right:24,zIndex:600,padding:"12px 20px",borderRadius:10,
          background:toast.ok?`${T.green}15`:`${T.red}15`,
          border:`1px solid ${toast.ok?T.green:T.red}40`,
          color:toast.ok?T.green:T.red,fontSize:13,fontWeight:700,
          boxShadow:T.shadow}}>
          {toast.msg}
        </div>
      )}
    </div>
  );
}
